import type { PlayableDir } from "../game/playable-facing.js";

/** Maps manifest ids to asset URLs — manifest Section 9 */
export function npcTexturePath(npcId: string): string {
  return `/assets/npcs/${npcId}/south.png`;
}

/** Eight-direction run sprites: `assets/npcs/<id>/rotations/<hyphenated-dir>.png` */
export function npcRotationTexturePathRotations(
  npcId: string,
  dir: PlayableDir
): string {
  return `/assets/npcs/${npcId}/rotations/${dir}.png`;
}

/** Stable Phaser texture key per npc + direction (hyphens kept). */
export function npcDirectionTextureKey(npcId: string, dir: PlayableDir): string {
  return `npc_art_${npcId}_${dir}`;
}

export function buildingTexturePath(
  zone: "city" | "suburb",
  category: string,
  buildingId: string
): string {
  return `/assets/buildings/${zone}/${category}/${buildingId}.png`;
}

/** e.g. `city_stores_11` / `suburb_homes_04` → disk path under `assets/buildings/`. */
export function buildingTextureUrl(buildingId: string): string {
  const parts = buildingId.split("_");
  const prefix = parts[0] ?? "city";
  const category = parts[1] ?? "misc";
  const zone: "city" | "suburb" = prefix === "suburb" ? "suburb" : "city";
  return buildingTexturePath(zone, category, buildingId);
}
